import './App.css';
import { AuthProvider } from './context/AuthContext';
import Navigation from './navigation/Navigation';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Navigation />
      </AuthProvider>
    </div>
  );
}

export default App;
